import { invariantResponse } from '@epic-web/invariant'
import { json, type LoaderFunctionArgs } from '@remix-run/node'
import { Link, useLoaderData, type MetaFunction } from '@remix-run/react'
import { brandName } from '#app/components/branding.js'
import { reactionTypes } from '#app/components/ui/reactions.js'
import { prisma } from '#app/utils/db.server.js'
import { type loader as reactionsLoader } from './reactions.tsx'

export async function loader({ params }: LoaderFunctionArgs) {

	const owner = await prisma.user.findFirst({
		select: {
			id: true,
			name: true,
			username: true,
			image: { select: { id: true } },
			Reaction: { 
				select: { id: true, type: true, commentId: true, scriptId: true, guideId: true, createdAt: true }, 
				where: { type: params.type },
			},
		},
		where: { username: params.username },
	})

	invariantResponse(owner, 'Not found', { status: 404 })

	const uniqueScriptIds = owner.Reaction.map((reaction) => reaction.scriptId);
	const scriptDetails = await prisma.script.findMany({
		where: { id: { in: uniqueScriptIds as string[] } },
	});

	// const uniqueCommentIds = owner.Reaction.map((reaction) => reaction.commentId);
	// // etc
	// const uniqueGuideIds = owner.Reaction.map((reaction) => reaction.guideId);
	// //etc

	// 	if (uniqueScriptIds !== null && uniqueScriptIds.length != 0) {

	// }

	return json({
		reactions: owner.Reaction,
		scriptDetails
	})
}


export default function ReactionTypeRoute() {
	const { reactions, scriptDetails } = useLoaderData<typeof loader>()
	return (
		<div className="container pt-12">
			{reactions.map((reaction) => 
			{
				var scriptName = scriptDetails.find((script) => script.id === reaction.scriptId)?.title;
				var reactionTypeIcon = reactionTypes.find((reactionType) => reactionType.type === reaction.type)?.icon;
				return <div key={reaction.id}>
					<Link to={`/script/${reaction.scriptId}`}>{reactionTypeIcon} {scriptName}</Link> 
				</div>
			})}
		</div>
	)
}

export const meta: MetaFunction<
	null,
	{ 'routes/users+/$username_+/reactions': typeof reactionsLoader }
> = ({ params, matches }) => {
	const notesMatch = matches.find(
		(m) => m.id === 'routes/users+/$username_+/reactions',
	)
	const displayName = notesMatch?.data?.owner.name ?? params.username
	const noteCount = notesMatch?.data?.owner.Reaction.length ?? 0
	const notesText = noteCount === 1 ? 'reaction' : 'reactions'
	return [
		{ title: `${displayName}'s Reactions | ${brandName}` },
		{
			name: 'description',
			content: `Checkout ${displayName}'s ${noteCount} ${notesText} on ${brandName}`,
		},
	]
}
